import React from "react";

import LoadingComponent from "react-loading-overlay";

import { useLoading } from "../../hooks/loading";
import { useIntl } from "react-intl";
import { LoadingSpinnerLogo, SpinnerContainer, SpinnerText } from "./styles";
import LogoCircle from "../../assets/images/Informa_Logo_Circle.png";

const LoadingOverlay = ({ children, additionalLoading = false }) => {
  const { isAccountLoading, isLoading } = useLoading();
  const intl = useIntl();

  return (
    <LoadingComponent
      active={isAccountLoading || isLoading || additionalLoading}
      spinner={
        <SpinnerContainer>
          <LoadingSpinnerLogo src={LogoCircle} />
          <SpinnerText>{intl.formatMessage({ id: "loading..." })}</SpinnerText>
        </SpinnerContainer>
      }
      styles={{
        overlay: (base) => ({
          ...base,
          zIndex: 9999999999999,
        }),
      }}
    >
      {children}
    </LoadingComponent>
  );
};

export default LoadingOverlay;
